export default "__VITE_ASSET__DQZGgxvu__"